import { gridSizeMdLg6, ROUTER_PATHS } from "@/shared";
import { usePostPlanCorporativo, usePutPlanCorporativo } from "@/shared/actions/erp/planes";
// import { usePostCapacidadCorporativo, usePutCapacidadCorporativo } from "@/shared/actions/erp/planes/planes_corporativos.actions";
import { CustomAutocompleteArrString, CustomNumberTextField, CustomTextField, SampleCheckbox, SingleFormBoxScene } from "@/shared/components/ui";
import { PERMANENCIA_PLAN_CORPORATIVO_CHOICE, PlanesCorporativos, PlanesCorporativosForm, TIPO_PLAN_CORPORATIVO_CHOICE } from "@/shared/interfaces";
import { PlanCorporativoSchema } from "@/shared/utils/validation-schemas/erp/planes_corporativo/planes_corporativo.schema";
// import { CapacidadCorporativa, CapacidadCorporativaForm } from "@/shared/interfaces/erp/planes_corporativos/planes_corporativos.interface";
// import { newCapacidadCorporativoSchema } from "@/shared/utils/validation-schemas/erp/capacidad_corporativo/capacidad_corporativo.schema";
import { yupResolver } from "@hookform/resolvers/yup";
// import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export interface SavePlanesCorporativosProps {
  titlePage: string;
  planCorporativo?: PlanesCorporativos;
}

export default function SavePlanesCorporativos({
  titlePage,
  planCorporativo
}: SavePlanesCorporativosProps) {

  const navigate = useNavigate();

  ///* mutations
  const createPlanCorporativo = usePostPlanCorporativo({
    navigate,
    returnUrl: ROUTER_PATHS.ventasCorporativas.planCorporativoNav
  });

  const { mutate: mutatePlanCorporativo } = usePutPlanCorporativo({
    navigate,
    returnUrl: ROUTER_PATHS.ventasCorporativas.planCorporativoNav
  })

  ///* form
  const form = useForm<PlanesCorporativosForm>({
    resolver: yupResolver(PlanCorporativoSchema as any),
    defaultValues: {
      estado: true,
      plan_personalizado: false
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* edit
    if (planCorporativo)
      return mutatePlanCorporativo({ id: planCorporativo.id_plan_coorporativo!, data: form.getValues() })

    ///* create
    return createPlanCorporativo.mutate(form.getValues());
  };

  useEffect(() => {
    if (planCorporativo) {
      reset(planCorporativo)
    }
  }, [planCorporativo])




  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(ROUTER_PATHS.ventasCorporativas.planCorporativoNav);
      }}
      onSave={handleSubmit(onSave)}
    >
      {/* <Grid {...gridSizeMdLg12} > */}
          {/* nombre: string; */}
          {/* tipo_plan: TipoPlanCorporativo; */}
          {/* permanencia: PermanenciaPlanCorporativo; */}
          {/* costo_instalacion: number; */}
          {/* valor: number; */}
          {/* capacidad: number; */}
        <CustomTextField
          label="Nombre"
          name="nombre"
          control={form.control}
          defaultValue={form.getValues().nombre || ''}
          error={errors.nombre}
          helperText={errors.nombre?.message ?? ''}
          size={gridSizeMdLg6}
        />
        <CustomAutocompleteArrString
          label="Tipo Enlace"
          name="tipo_plan"
          isLoadingData={false}
          options={TIPO_PLAN_CORPORATIVO_CHOICE}
          control={form.control}
          defaultValue={form.getValues().tipo_plan || ''}
          error={errors.tipo_plan}
          helperText={errors.tipo_plan?.message ?? ''}
          size={gridSizeMdLg6}
        />
        <CustomAutocompleteArrString
          label="Permanencia"
          name="permanencia"
          isLoadingData={false}
          options={PERMANENCIA_PLAN_CORPORATIVO_CHOICE}
          control={form.control}
          defaultValue={form.getValues().permanencia || ''}
          error={errors.permanencia}
          helperText={errors.permanencia?.message ?? ''}
          size={gridSizeMdLg6}
        />
        <CustomNumberTextField
          label="Costo Instalacion"
          name="costo_instalacion"
          control={form.control}
          defaultValue={form.getValues().costo_instalacion || ''}
          error={errors.costo_instalacion}
          helperText={errors.costo_instalacion?.message ?? ''}
          isPositive
          step={0.1}
          min={0}
          max={10000}
          size={gridSizeMdLg6}
        />
        <CustomNumberTextField
          label="Valor Mensual"
          name="valor"
          control={form.control}
          defaultValue={form.getValues().valor || ''}
          error={errors.valor}
          helperText={errors.valor?.message ?? ''}
          isPositive
          step={0.1}
          min={0}
          max={10000}
          size={gridSizeMdLg6}
          textPlaceholder={"Valor mensual de la capacidad"}
        />
        <CustomNumberTextField
          label="Enlace"
          name="capacidad"
          control={form.control}
          defaultValue={form.getValues().capacidad || ''}
          error={errors.capacidad}
          helperText={errors.capacidad?.message ?? ''}
          isPositive
          step={0.1}
          min={0}
          max={10000}
          size={gridSizeMdLg6}
          textPlaceholder={"Ingrese la capacidad del enlace"}
        />


      {/* </Grid> */}

      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
        size={gridSizeMdLg6}
      />
    </SingleFormBoxScene>
  );

}